import moment from 'moment'
import 'moment/locale/es'
import { mapGetters } from 'vuex'

moment.updateLocale("es", {
  invalidDate: "00-00-0000"
});

export const global = {
  data() {
    return {
        APP_NAME: process.env.APP_NAME
      }
    },
    methods: {
        _fcurrency(currency_code, precision = 2) {
          let _currency_code = "";
          let symbol = ""
          if (currency_code) {
            _currency_code = currency_code.trim().toUpperCase();
            if (_currency_code === "USD") {
              symbol = "US$"
            } else if (_currency_code === "C$") {
              symbol = "C$"
            }
          } else {
            _currency_code = "";
          }

          return {
            decimal: ".",
            thousands: ",",
            prefix: symbol,
            suffix: " ",
            precision: precision,
            masked: false
          };
        },
        _number(pre = '', suf = '', prec = 2) {
          return {
            decimal: ".",
            thousands: ",",
            prefix: pre,
            suffix: suf,
            precision: prec,
            masked: false
          };
        },
        _fdate(date, format){
          if (!format) {
            format = "DD-MM-YYYY"
          }
          if (date === '' || date === "1900-01-01") return ''

          return moment(date).utc().format(format);
        },
        _symbolMoney(currency_code){
          let _currency_code = "";
          if (currency_code) {
            _currency_code = currency_code.trim();
          } else {
            _currency_code = "";
          }

          if (_currency_code == "USD") return "US$"
          return currency_code;
        },
        _formatter(number, option) {
          if (isNaN(number)) return 0
          if ('minimumFractionDigits' in option && 'maximumFractionDigits' in option) {
            option.minimumFractionDigits = Math.min(option.minimumFractionDigits, option.maximumFractionDigits)
            option.maximumFractionDigits = Math.max(option.minimumFractionDigits, option.maximumFractionDigits)
          }

          return number.toLocaleString("es-NI", option)
        },
        _currency(number, decimals = 0) {
          return number.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    computed: {
      ...mapGetters('auth', ['hasPermission','isAdmin'])
    }
}



// WEBPACK FOOTER //
// ./src/mixins/global.js